import { useEffect, useState } from 'react'

import { useLayoutStore } from '@/store/layout'

export function useSSRGridLayout() {
  const [layout, setLayout] = useState(0)

  useEffect(() => {
    const unsubscribe = useLayoutStore.subscribe((state) => state.gridLayout, setLayout, {
      fireImmediately: true
    })

    return () => {
      unsubscribe()
    }
  }, [])

  return layout
}
